﻿import React, { useEffect, useRef, useState } from 'react';

import { getEpiDataFromElement } from '../../../Utils/epiHelpers';


const VideoBlock = (props) => {

    const heading = getEpiDataFromElement('heading', props.element) || '';
    const text = getEpiDataFromElement('text', props.element) || '';
    const autoStartBackgroundVideo = getEpiDataFromElement('autoStartBackgroundVideo', props.element) === 'True';
    const backgroundVideoDesktop = getEpiDataFromElement('backgroundVideoLandscape', props.element) || '';
    const fallbackImageDesktop = getEpiDataFromElement('fallbackImageLandscape', props.element) || '';
    const backgroundVideoMobile = getEpiDataFromElement('backgroundVideoPortrait', props.element) || '';
    const fallbackImageMobile = getEpiDataFromElement('fallbackImagePortrait', props.element) || '';
    const playBackgroundVideoButton = getEpiDataFromElement('playBackgroundVideoButtonText', props.element) || '';
    const pauseBackgroundVideoButton = getEpiDataFromElement('pauseBackgroundVideoButtonText', props.element) || '';
    const playVideoButton = getEpiDataFromElement('playFullVersionButtonText', props.element) || '';
    const videoLinkDesktop = getEpiDataFromElement('videoLinkLandscape', props.element) || '';
    const videoLinkMobile = getEpiDataFromElement('videoLinkPortrait', props.element) || '';


    const viewportSize = document.body.getBoundingClientRect().width

    const backgroundVideoRef = useRef(null)
    const youtubeVideoRef = useRef(null)

    const playBackgroundVideo = () => {
        backgroundVideoRef.current.play()
        setBackgroundVideoPlaying(true)
    }

    const pauseBackgroundVideo = () => {
        backgroundVideoRef.current.pause()
        setBackgroundVideoPlaying(false)
    }

    const playYoutubeVideo = () => {
        setPlayYoutube(true)
    }

    const getFallbackImage = (viewportSize) => {
        if (viewportSize > 620) {
            return fallbackImageDesktop
        } else {
            return fallbackImageMobile
        }
    }

    const getBackgroundVideo = (viewportSize) => {
        if (viewportSize > 620) {
            return backgroundVideoDesktop
        } else {
            return backgroundVideoMobile
        }
    }

    const getYoutubeVideo = (viewportSize) => {
        if (viewportSize > 620) {
            return videoLinkDesktop
        } else {
            return videoLinkMobile
        }
    }

    const clickedToggleVideo = (isPLaying) => {
        return () => {
            if (isPLaying) {
                pauseBackgroundVideo()
            } else {
                playBackgroundVideo()
            }
        }
    }

    const [backgroundVideoPlaying, setBackgroundVideoPlaying] = useState(autoStartBackgroundVideo)
    const [playYotube, setPlayYoutube] = useState(false)
    const [fallbackImage, setFallbackImage] = useState(getFallbackImage(viewportSize))
    const [fallbackVideo, setFallbackVideo] = useState(getBackgroundVideo(viewportSize))
    const [youtubeLink, setYoutubelink] = useState(getYoutubeVideo(viewportSize))


    return (
        < div className="video block-spacing" >

            <div className="video__container">

                <video
                    ref={backgroundVideoRef}
                    autoPlay={autoStartBackgroundVideo}
                    muted
                    loop={true}
                    src={fallbackVideo}
                    className="video__container__loop"
                    poster={fallbackImage}
                    type="video/mp4"                   
                    playsInline
                />

                {playYotube && youtubeLink &&
                    <iframe src={youtubeLink + "?autoplay=1&rel=0"} allow="autoplay" allowFullScreen="allowFullScreen" frameBorder="0"></iframe>
                }
               

            </div>

            {!playYotube &&
                <>
                    <div className="video__overlay"></div>

                    <div className="video__content">
                        <h2 className="video__content__title">{heading}</h2>
                        <div className="video__content__text" dangerouslySetInnerHTML={{ __html: text }} />

                        {youtubeLink && 
                            <button ref={youtubeVideoRef} onClick={playYoutubeVideo} className="video__content__play-youtube">{playVideoButton}</button>
                        }
                    </div >

                    <ToggleVideoButton
                        isPlaying={backgroundVideoPlaying}
                        labelPlay={playBackgroundVideoButton}
                        labelPause={pauseBackgroundVideoButton}
                        onClick={clickedToggleVideo(backgroundVideoPlaying)}
                    />
                </>
            }
        </div >
    )
}

export default VideoBlock

const ToggleVideoButton = ({onClick, isPlaying, labelPlay, labelPause }) => {
    return (
        <button
            onClick={onClick}
            className="video__content__control-button">
            {isPlaying ? labelPause : labelPlay}
            <img className="video__content__control-button__icon" src={`/images/${isPlaying ? 'pause' : 'play-video'}.svg`} />
        </button>
    )
}